import { odata } from '@bingads-webui/http-util';
import { getOdataConfig } from './odata-config';

export const inlineUpdateTasks = async (scope, updatedPrefernce) => {
  const odataConfig = getOdataConfig();
  const { aid, cid } = scope;
  const getUrl = taskId => `/Advertiser/V2/Customers(${cid})/Accounts(${aid})/TaskItems(${taskId})/PatchImportTaskItemUserPreference`;

  const reqs = updatedPrefernce.map(v => ({
    type: 'PATCH',
    url: getUrl(v.taskId),
    data: {
      '@odata.type': '#Model.ImportUserPreference',
      ...v.preference,
    },
  }));

  return odata.batch({
    reqs,
    batchURL: `${odataConfig.oDataPath}/$batch`,
    needContentType: true,
    headers: {
      Authorization: `CCMTSmallToken ${odataConfig.oDataToken}`,
    },
  });
};
